export default {
  nav: {
    home: 'Inicio',
    builder: 'GPAX Builder',
    transformer: 'GPAX Transformer',
    audit: 'GPAX Audit',
    why: '¿Por qué Infoware S. A.?',
    contact: 'Contactar',
    language: 'Español',
  },
  footer: {
    description: 'Más de 20 años innovando en Latinoamérica con soluciones de interoperabilidad y automatización de procesos estratégicos.',
    talk: 'Habla con nosotros',
    products: 'Productos',
    company: 'Empresa',
    contact: 'Contacto',
    legal: 'Legal',
    whyInfoware: '¿Por qué Infoware S. A.?',
    ourCommitment: 'Nuestro compromiso',
    certifications: 'Certificaciones',
    terms: 'Términos y Servicios',
    privacy: 'Política de Privacidad',
    sla: 'SLA',
    rights: 'Todos los derechos reservados.',
    carbonNeutral: 'Carbono Neutral',
  },
};